import {
  COR_PONTO_ESTADO_GERAL,
  SUBTITULO_ESTADO_GERAL,
  TITULO_ESTADO_GERAL,
} from '@/constants/status.constants';
import type { EstadoServico, ItemResumo } from '@/types/status.types';

type EstadoGlobalProps = {
  estado: EstadoServico;
  resumo: ItemResumo[];
};

export const EstadoGlobal = ({ estado, resumo }: EstadoGlobalProps) => {
  return (
    <section
      className="cartao-status px-6 py-7"
      aria-live="polite"
      aria-atomic="true"
      aria-label="Estado geral dos serviços"
    >
      <div className="flex items-start gap-3.5">
        <span
          aria-hidden="true"
          className="mt-2 size-3.5 flex-none rounded-full"
          style={{ background: COR_PONTO_ESTADO_GERAL[estado] }}
        />
        <div className="min-w-0 flex-1">
          <h1 className="m-0 text-[30px] font-semibold tracking-[-0.025em] text-pretty">
            {TITULO_ESTADO_GERAL[estado]}
          </h1>
          <p className="mt-2 mb-0 text-[14px] leading-[1.55] text-pretty text-muted-foreground">
            {SUBTITULO_ESTADO_GERAL[estado]}
          </p>
        </div>
      </div>

      {resumo.length > 0 && (
        <dl className="mt-[22px] flex flex-wrap gap-x-[26px] gap-y-4 border-t border-border pt-[18px]">
          {resumo.map((item) => (
            <div key={item.rotulo}>
              <dt className="text-[11px] font-semibold tracking-[0.06em] text-muted-foreground uppercase">
                {item.rotulo}
              </dt>
              <dd className="m-0 mt-[5px] text-[16px] font-semibold">{item.valor}</dd>
            </div>
          ))}
        </dl>
      )}
    </section>
  );
};
